<template>
<div class="partners-content">
  <div class="content">
    <div class="title-name">合作伙伴</div>
    <div class="list">
      <div class="item"><img src="@/assets/img/partners/cus_01_pre.jpg"></div>
      <div class="item"><img src="@/assets/img/partners/cus_02_pre.jpg"></div>
      <div class="item"><img src="@/assets/img/partners/cus_03_pre.jpg"></div>
      <div class="item"><img src="@/assets/img/partners/cus_04_pre.jpg"></div>
      <div class="item"><img src="@/assets/img/partners/cus_05_pre.jpg"></div>
      <div class="item"><img src="@/assets/img/partners/cus_06_pre.jpg"></div>
      <div class="item"><img src="@/assets/img/partners/cus_07_pre.jpg"></div>
      <div class="item"><img src="@/assets/img/partners/cus_08_pre.jpg"></div>
      <div class="item"><img src="@/assets/img/partners/cus_09_pre.jpg"></div>
      <div class="item"><img src="@/assets/img/partners/cus_10_pre.jpg"></div>
      <div class="item"><img src="@/assets/img/partners/cus_11_pre.jpg"></div>
      <div class="item"><img src="@/assets/img/partners/cus_12_pre.jpg"></div>
      <div class="item"><img src="@/assets/img/partners/cus_13_pre.jpg"></div>
      <div class="item"><img src="@/assets/img/partners/cus_14_pre.jpg"></div>
      <div class="item"><img src="@/assets/img/partners/cus_15_pre.jpg"></div>
      <div class="item"><img src="@/assets/img/partners/cus_16_pre.jpg"></div>
      <div class="item"><img src="@/assets/img/partners/cus_17_pre.jpg"></div>
      <div class="item"><img src="@/assets/img/partners/cus_18_pre.jpg"></div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: ''
}
</script>

<style scoped lang="less">
.partners-content{
    width: 100%;
    overflow: visible;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 10px;
    box-sizing: border-box;
    .content{
      width: 1200px;
      overflow: visible;
      display: flex;
      flex-direction: column;
      align-items: center;
      box-sizing: border-box;
      .title-name{
        height: 38px;
        color: #333333;
        transform: .5s;
        line-height: 38px;
        font-size: 30px;
        margin-bottom: 30px;
        box-sizing: border-box;
      }
      .list{
        width: 100%;
        display: -webkit-flex;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-bottom: 71px;
        box-sizing: border-box;
        .item{
          width: 180px;
          box-sizing: border-box;
          img{
            width: 100%;
            vertical-align: middle;
          }
        }
      }
    }
}
</style>
